"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPluginData = createPluginData;
exports.collectPluginProps = collectPluginProps;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function createPluginData(_x, _x2) {
  return _createPluginData.apply(this, arguments);
}

function _createPluginData() {
  _createPluginData = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(plugins, options) {
    var createContextKey, allContextToResolve, _i2, _Object$keys2, key, p, createEitherContext, result, _i3, _allContextToResolve, _allContextToResolve$, _key, ctxPromise;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            createContextKey = options.isServer ? 'createServerContext' : 'createClientContext';
            allContextToResolve = [];

            for (_i2 = 0, _Object$keys2 = Object.keys(plugins); _i2 < _Object$keys2.length; _i2++) {
              key = _Object$keys2[_i2];
              p = plugins[key];
              createEitherContext = p[createContextKey];

              if (createEitherContext) {
                allContextToResolve.push({
                  key: key,
                  ctxPromise: createEitherContext({
                    ctx: options.ctx
                  })
                });
              }
            } // step(awaitAll): wait until all context from all plugins is resolved


            _context.next = 5;
            return Promise.all(allContextToResolve.map(function (_) {
              return _.ctxPromise;
            }));

          case 5:
            result = {};
            _i3 = 0, _allContextToResolve = allContextToResolve;

          case 7:
            if (!(_i3 < _allContextToResolve.length)) {
              _context.next = 15;
              break;
            }

            _allContextToResolve$ = _allContextToResolve[_i3], _key = _allContextToResolve$.key, ctxPromise = _allContextToResolve$.ctxPromise;
            _context.next = 11;
            return ctxPromise;

          case 11:
            result[_key] = _context.sent;

          case 12:
            _i3++;
            _context.next = 7;
            break;

          case 15:
            return _context.abrupt("return", result);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createPluginData.apply(this, arguments);
}

function collectPluginProps(plugins, pluginData) {
  var res = {};

  for (var _i = 0, _Object$keys = Object.keys(plugins); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var p = plugins[key];

    if (p.provideProps) {
      var ctx = pluginData[key];
      res[key] = p.provideProps(ctx);
    } else {
      res[key] = {};
    }
  }

  return res;
}